/* Onewheelers scroll-reveals + micro-motion.
 * Elementen glijden subtiel omhoog wanneer ze in beeld komen.
 * Met prefers-reduced-motion gebeurt er niets. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = [
    '.card-wrapper',
    '.title-wrapper-with-link',
    '.collection .title',
    '.ow-splitx__media', '.ow-splitx__info',
    '.ow-bannerx__content',
    '.ow-ig__kicker', '.ow-ig__heading', '.ow-ig__handle', '.ow-ig__item',
    '.ow-reels__item',
    '.ow-stmt__text',
    '.ow-outro__heading', '.ow-outro__text',
    '.ow-count__inner',
    '.footer-block',
    '.multicolumn-card',
    '.image-with-text__content', '.image-with-text__media'
  ].join(',');

  function prep() {
    var els = document.querySelectorAll(SELECTORS);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ow-inview');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    var groupCounters = new Map();
    els.forEach(function (el) {
      if (el.classList.contains('ow-reveal')) return;
      el.classList.add('ow-reveal');
      // kleine stagger binnen dezelfde ouder (kaarten naast elkaar)
      var parent = el.parentElement;
      var n = (groupCounters.get(parent) || 0);
      groupCounters.set(parent, n + 1);
      el.style.transitionDelay = Math.min(n * 70, 350) + 'ms';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prep);
  } else {
    prep();
  }
  document.addEventListener('shopify:section:load', prep);
})();
